import * as React from "react";
import classnames from "classnames";
import Button from "../../Button/Button/Button.js";
/* empty css                */
import { useBreakpoint } from "../../MediaQuery/MediaQuery/MediaQueryContext.js";
const Expandable = ({
  initialHeight = 0,
  showLessLabel,
  showMoreLabel,
  className,
  children,
  id
}) => {
  const currentBreakpoint = useBreakpoint();
  const contentContainerRef = React.useRef(null);
  const shouldUpdateToggleRef = React.useRef(true);
  const [isExpanded, setIsExpanded] = React.useReducer((isExpanded2) => !isExpanded2, false);
  const [showButton, setShowButton] = React.useState(true);
  React.useEffect(() => {
    shouldUpdateToggleRef.current = !isExpanded;
  }, [isExpanded]);
  React.useEffect(() => {
    const contentContainer = contentContainerRef.current;
    if (!shouldUpdateToggleRef.current || !contentContainer) {
      return;
    }
    const updateInertState = () => {
      const containerBounds = contentContainer.getBoundingClientRect();
      contentContainer.querySelectorAll("*").forEach((child) => {
        const childBounds = child.getBoundingClientRect();
        const isHidden = childBounds.right < containerBounds.left || childBounds.left > containerBounds.right || childBounds.bottom < containerBounds.top || childBounds.top > containerBounds.bottom;
        child.inert = isHidden;
      });
    };
    const resizeObserver = new ResizeObserver(updateInertState);
    resizeObserver.observe(contentContainer);
    updateInertState();
    const { height } = contentContainer.getBoundingClientRect();
    setShowButton(contentContainer.scrollHeight > Math.ceil(height));
    return () => resizeObserver.disconnect();
  }, [contentContainerRef, shouldUpdateToggleRef, currentBreakpoint]);
  if (!children) {
    return null;
  }
  const toggleText = isExpanded ? showLessLabel : showMoreLabel;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classnames("expandable", className, {
        _is_expanded: isExpanded,
        "expandable--with-button": showButton
      })
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        id: `expandable-${id}`,
        className: "expandable__body",
        style: { maxHeight: `${initialHeight}px` },
        ref: contentContainerRef
      },
      children
    ),
    showButton && /* @__PURE__ */ React.createElement(
      Button,
      {
        variant: "ghost",
        onClick: setIsExpanded,
        "aria-expanded": isExpanded,
        "aria-controls": `expandable-${id}`,
        caption: toggleText,
        size: "custom"
      }
    )
  );
};
export {
  Expandable as default
};
//# sourceMappingURL=Expandable.js.map
